/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SynthwaveRouteImport } from './routes/synthwave'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedDocsAviaryRouteImport } from './routes/_authenticated/docs/aviary'
import { Route as AuthenticatedAdminDemoRouteImport } from './routes/_authenticated/admin/demo'
import { Route as AuthenticatedOpportunityOpportunityIdRouteRouteImport } from './routes/_authenticated/opportunity/$opportunityId/route'
import { Route as AuthenticatedOpportunityOpportunityIdIndexRouteImport } from './routes/_authenticated/opportunity/$opportunityId/index'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminOrganizationsIndexRouteImport } from './routes/_authenticated/admin/organizations/index'
import { Route as AuthenticatedAdminUsersUserIdRouteImport } from './routes/_authenticated/admin/users/$userId'
import { Route as AuthenticatedAdminOpportunitiesRandomRouteImport } from './routes/_authenticated/admin/opportunities.random'
import { Route as AuthenticatedAdminContactsRandomRouteImport } from './routes/_authenticated/admin/contacts.random'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/route'
import { Route as AuthenticatedAdminOpportunityOpportunityIdRouteRouteImport } from './routes/_authenticated/admin/opportunity.$opportunityId/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdIndexRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/index'
import { Route as AuthenticatedAdminOpportunityOpportunityIdIndexRouteImport } from './routes/_authenticated/admin/opportunity.$opportunityId/index'
import { Route as AuthenticatedAdminAviaryTasksIndexRouteImport } from './routes/_authenticated/admin/aviary/tasks/index'
import { Route as AuthenticatedAdminAviaryTasksTaskIdRouteImport } from './routes/_authenticated/admin/aviary/tasks/$taskId'
import { Route as AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteImport } from './routes/_authenticated/opportunity/$opportunityId/contact.$contactId/route'
import { Route as AuthenticatedOpportunityOpportunityIdContactContactIdIndexRouteImport } from './routes/_authenticated/opportunity/$opportunityId/contact.$contactId/index'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/users.$userId'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/contacts.$contactId/route'
import { Route as AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteImport } from './routes/_authenticated/admin/opportunity.$opportunityId/contact.$contactId/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/index'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/contacts.$contactId/index'
import { Route as AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRouteImport } from './routes/_authenticated/admin/opportunity.$opportunityId/contact.$contactId/index'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/requirements/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/contacts/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/requirements/$requirementsId'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/contacts/$contactId/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/contacts/$contactId/index'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/contacts/$contactId/evaluations/route'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRouteImport } from './routes/_authenticated/admin/organizations/$organizationId/opportunities.$opportunityId/contacts/$contactId/evaluations/$evaluationId'

const SynthwaveRoute = SynthwaveRouteImport.update({
  id: '/synthwave',
  path: '/synthwave',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedDocsAviaryRoute = AuthenticatedDocsAviaryRouteImport.update({
  id: '/docs/aviary',
  path: '/docs/aviary',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminDemoRoute = AuthenticatedAdminDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedOpportunityOpportunityIdRouteRoute =
  AuthenticatedOpportunityOpportunityIdRouteRouteImport.update({
    id: '/opportunity/$opportunityId',
    path: '/opportunity/$opportunityId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOpportunityOpportunityIdIndexRoute =
  AuthenticatedOpportunityOpportunityIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunityOpportunityIdRouteRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminUsersUserIdRoute =
  AuthenticatedAdminUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOpportunitiesRandomRoute =
  AuthenticatedAdminOpportunitiesRandomRouteImport.update({
    id: '/opportunities/random',
    path: '/opportunities/random',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminContactsRandomRoute =
  AuthenticatedAdminContactsRandomRouteImport.update({
    id: '/contacts/random',
    path: '/contacts/random',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrganizationIdRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOpportunityOpportunityIdRouteRoute =
  AuthenticatedAdminOpportunityOpportunityIdRouteRouteImport.update({
    id: '/opportunity/$opportunityId',
    path: '/opportunity/$opportunityId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrganizationIdIndexRoute =
  AuthenticatedAdminOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedAdminOpportunityOpportunityIdIndexRoute =
  AuthenticatedAdminOpportunityOpportunityIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminOpportunityOpportunityIdRouteRoute,
  } as any)
const AuthenticatedAdminAviaryTasksIndexRoute =
  AuthenticatedAdminAviaryTasksIndexRouteImport.update({
    id: '/aviary/tasks/',
    path: '/aviary/tasks/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminAviaryTasksTaskIdRoute =
  AuthenticatedAdminAviaryTasksTaskIdRouteImport.update({
    id: '/aviary/tasks/$taskId',
    path: '/aviary/tasks/$taskId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute =
  AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteImport.update({
    id: '/contact/$contactId',
    path: '/contact/$contactId',
    getParentRoute: () => AuthenticatedOpportunityOpportunityIdRouteRoute,
  } as any)
const AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute =
  AuthenticatedOpportunityOpportunityIdContactContactIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute =
  AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () =>
      AuthenticatedAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteImport.update(
    {
      id: '/opportunities/$opportunityId',
      path: '/opportunities/$opportunityId',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteImport.update(
    {
      id: '/contacts/$contactId',
      path: '/contacts/$contactId',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute =
  AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteImport.update(
    {
      id: '/contact/$contactId',
      path: '/contact/$contactId',
      getParentRoute: () =>
        AuthenticatedAdminOpportunityOpportunityIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute =
  AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute =
  AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteImport.update(
    {
      id: '/requirements',
      path: '/requirements',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteImport.update(
    {
      id: '/contacts',
      path: '/contacts',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRouteImport.update(
    {
      id: '/$requirementsId',
      path: '/$requirementsId',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteImport.update(
    {
      id: '/$contactId',
      path: '/$contactId',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteImport.update(
    {
      id: '/evaluations',
      path: '/evaluations',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute,
    } as any,
  )
const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRouteImport.update(
    {
      id: '/$evaluationId',
      path: '/$evaluationId',
      getParentRoute: () =>
        AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/synthwave': typeof SynthwaveRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/opportunity/$opportunityId': typeof AuthenticatedOpportunityOpportunityIdRouteRouteWithChildren
  '/admin/demo': typeof AuthenticatedAdminDemoRoute
  '/docs/aviary': typeof AuthenticatedDocsAviaryRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/admin/opportunity/$opportunityId': typeof AuthenticatedAdminOpportunityOpportunityIdRouteRouteWithChildren
  '/admin/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/admin/contacts/random': typeof AuthenticatedAdminContactsRandomRoute
  '/admin/opportunities/random': typeof AuthenticatedAdminOpportunitiesRandomRoute
  '/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/opportunity/$opportunityId/': typeof AuthenticatedOpportunityOpportunityIdIndexRoute
  '/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
  '/admin/aviary/tasks/$taskId': typeof AuthenticatedAdminAviaryTasksTaskIdRoute
  '/admin/aviary/tasks/': typeof AuthenticatedAdminAviaryTasksIndexRoute
  '/admin/opportunity/$opportunityId/': typeof AuthenticatedAdminOpportunityOpportunityIdIndexRoute
  '/admin/organizations/$organizationId/': typeof AuthenticatedAdminOrganizationsOrganizationIdIndexRoute
  '/admin/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
  '/admin/organizations/$organizationId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteWithChildren
  '/admin/organizations/$organizationId/users/$userId': typeof AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute
  '/opportunity/$opportunityId/contact/$contactId/': typeof AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren
  '/admin/opportunity/$opportunityId/contact/$contactId/': typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute
  '/admin/organizations/$organizationId/contacts/$contactId/': typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute
}
export interface FileRoutesByTo {
  '/synthwave': typeof SynthwaveRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/demo': typeof AuthenticatedAdminDemoRoute
  '/docs/aviary': typeof AuthenticatedDocsAviaryRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/admin/contacts/random': typeof AuthenticatedAdminContactsRandomRoute
  '/admin/opportunities/random': typeof AuthenticatedAdminOpportunitiesRandomRoute
  '/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
  '/opportunity/$opportunityId': typeof AuthenticatedOpportunityOpportunityIdIndexRoute
  '/admin/aviary/tasks/$taskId': typeof AuthenticatedAdminAviaryTasksTaskIdRoute
  '/admin/aviary/tasks': typeof AuthenticatedAdminAviaryTasksIndexRoute
  '/admin/opportunity/$opportunityId': typeof AuthenticatedAdminOpportunityOpportunityIdIndexRoute
  '/admin/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdIndexRoute
  '/admin/organizations/$organizationId/users/$userId': typeof AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute
  '/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren
  '/admin/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute
  '/admin/organizations/$organizationId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute
  '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/synthwave': typeof SynthwaveRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/opportunity/$opportunityId': typeof AuthenticatedOpportunityOpportunityIdRouteRouteWithChildren
  '/_authenticated/admin/demo': typeof AuthenticatedAdminDemoRoute
  '/_authenticated/docs/aviary': typeof AuthenticatedDocsAviaryRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/admin/opportunity/$opportunityId': typeof AuthenticatedAdminOpportunityOpportunityIdRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/_authenticated/admin/contacts/random': typeof AuthenticatedAdminContactsRandomRoute
  '/_authenticated/admin/opportunities/random': typeof AuthenticatedAdminOpportunitiesRandomRoute
  '/_authenticated/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/_authenticated/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/_authenticated/opportunity/$opportunityId/': typeof AuthenticatedOpportunityOpportunityIdIndexRoute
  '/_authenticated/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
  '/_authenticated/admin/aviary/tasks/$taskId': typeof AuthenticatedAdminAviaryTasksTaskIdRoute
  '/_authenticated/admin/aviary/tasks/': typeof AuthenticatedAdminAviaryTasksIndexRoute
  '/_authenticated/admin/opportunity/$opportunityId/': typeof AuthenticatedAdminOpportunityOpportunityIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/': typeof AuthenticatedAdminOrganizationsOrganizationIdIndexRoute
  '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId': typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/users/$userId': typeof AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute
  '/_authenticated/opportunity/$opportunityId/contact/$contactId/': typeof AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren
  '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId/': typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/contacts/$contactId/': typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute
  '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId': typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/synthwave'
    | '/admin'
    | '/opportunity/$opportunityId'
    | '/admin/demo'
    | '/docs/aviary'
    | '/admin/'
    | '/admin/opportunity/$opportunityId'
    | '/admin/organizations/$organizationId'
    | '/admin/contacts/random'
    | '/admin/opportunities/random'
    | '/admin/users/$userId'
    | '/admin/organizations/'
    | '/admin/users/'
    | '/opportunity/$opportunityId/'
    | '/opportunity/$opportunityId/contact/$contactId'
    | '/admin/aviary/tasks/$taskId'
    | '/admin/aviary/tasks/'
    | '/admin/opportunity/$opportunityId/'
    | '/admin/organizations/$organizationId/'
    | '/admin/opportunity/$opportunityId/contact/$contactId'
    | '/admin/organizations/$organizationId/contacts/$contactId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId'
    | '/admin/organizations/$organizationId/users/$userId'
    | '/opportunity/$opportunityId/contact/$contactId/'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements'
    | '/admin/opportunity/$opportunityId/contact/$contactId/'
    | '/admin/organizations/$organizationId/contacts/$contactId/'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/synthwave'
    | '/'
    | '/admin/demo'
    | '/docs/aviary'
    | '/admin'
    | '/admin/contacts/random'
    | '/admin/opportunities/random'
    | '/admin/users/$userId'
    | '/admin/organizations'
    | '/admin/users'
    | '/opportunity/$opportunityId'
    | '/admin/aviary/tasks/$taskId'
    | '/admin/aviary/tasks'
    | '/admin/opportunity/$opportunityId'
    | '/admin/organizations/$organizationId'
    | '/admin/organizations/$organizationId/users/$userId'
    | '/opportunity/$opportunityId/contact/$contactId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements'
    | '/admin/opportunity/$opportunityId/contact/$contactId'
    | '/admin/organizations/$organizationId/contacts/$contactId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId'
    | '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/synthwave'
    | '/_authenticated/admin'
    | '/_authenticated/'
    | '/_authenticated/opportunity/$opportunityId'
    | '/_authenticated/admin/demo'
    | '/_authenticated/docs/aviary'
    | '/_authenticated/admin/'
    | '/_authenticated/admin/opportunity/$opportunityId'
    | '/_authenticated/admin/organizations/$organizationId'
    | '/_authenticated/admin/contacts/random'
    | '/_authenticated/admin/opportunities/random'
    | '/_authenticated/admin/users/$userId'
    | '/_authenticated/admin/organizations/'
    | '/_authenticated/admin/users/'
    | '/_authenticated/opportunity/$opportunityId/'
    | '/_authenticated/opportunity/$opportunityId/contact/$contactId'
    | '/_authenticated/admin/aviary/tasks/$taskId'
    | '/_authenticated/admin/aviary/tasks/'
    | '/_authenticated/admin/opportunity/$opportunityId/'
    | '/_authenticated/admin/organizations/$organizationId/'
    | '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId'
    | '/_authenticated/admin/organizations/$organizationId/contacts/$contactId'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId'
    | '/_authenticated/admin/organizations/$organizationId/users/$userId'
    | '/_authenticated/opportunity/$opportunityId/contact/$contactId/'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements'
    | '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId/'
    | '/_authenticated/admin/organizations/$organizationId/contacts/$contactId/'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/'
    | '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SynthwaveRoute: typeof SynthwaveRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/synthwave': {
      id: '/synthwave'
      path: '/synthwave'
      fullPath: '/synthwave'
      preLoaderRoute: typeof SynthwaveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/docs/aviary': {
      id: '/_authenticated/docs/aviary'
      path: '/docs/aviary'
      fullPath: '/docs/aviary'
      preLoaderRoute: typeof AuthenticatedDocsAviaryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/demo': {
      id: '/_authenticated/admin/demo'
      path: '/demo'
      fullPath: '/admin/demo'
      preLoaderRoute: typeof AuthenticatedAdminDemoRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/opportunity/$opportunityId': {
      id: '/_authenticated/opportunity/$opportunityId'
      path: '/opportunity/$opportunityId'
      fullPath: '/opportunity/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOpportunityOpportunityIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/opportunity/$opportunityId/': {
      id: '/_authenticated/opportunity/$opportunityId/'
      path: '/'
      fullPath: '/opportunity/$opportunityId/'
      preLoaderRoute: typeof AuthenticatedOpportunityOpportunityIdIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunityOpportunityIdRouteRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/organizations/': {
      id: '/_authenticated/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/users/$userId': {
      id: '/_authenticated/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AuthenticatedAdminUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/opportunities/random': {
      id: '/_authenticated/admin/opportunities/random'
      path: '/opportunities/random'
      fullPath: '/admin/opportunities/random'
      preLoaderRoute: typeof AuthenticatedAdminOpportunitiesRandomRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/contacts/random': {
      id: '/_authenticated/admin/contacts/random'
      path: '/contacts/random'
      fullPath: '/admin/contacts/random'
      preLoaderRoute: typeof AuthenticatedAdminContactsRandomRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId': {
      id: '/_authenticated/admin/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/admin/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/opportunity/$opportunityId': {
      id: '/_authenticated/admin/opportunity/$opportunityId'
      path: '/opportunity/$opportunityId'
      fullPath: '/admin/opportunity/$opportunityId'
      preLoaderRoute: typeof AuthenticatedAdminOpportunityOpportunityIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/': {
      id: '/_authenticated/admin/organizations/$organizationId/'
      path: '/'
      fullPath: '/admin/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/admin/opportunity/$opportunityId/': {
      id: '/_authenticated/admin/opportunity/$opportunityId/'
      path: '/'
      fullPath: '/admin/opportunity/$opportunityId/'
      preLoaderRoute: typeof AuthenticatedAdminOpportunityOpportunityIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOpportunityOpportunityIdRouteRoute
    }
    '/_authenticated/admin/aviary/tasks/': {
      id: '/_authenticated/admin/aviary/tasks/'
      path: '/aviary/tasks'
      fullPath: '/admin/aviary/tasks/'
      preLoaderRoute: typeof AuthenticatedAdminAviaryTasksIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/aviary/tasks/$taskId': {
      id: '/_authenticated/admin/aviary/tasks/$taskId'
      path: '/aviary/tasks/$taskId'
      fullPath: '/admin/aviary/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedAdminAviaryTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/opportunity/$opportunityId/contact/$contactId': {
      id: '/_authenticated/opportunity/$opportunityId/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/opportunity/$opportunityId/contact/$contactId'
      preLoaderRoute: typeof AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteImport
      parentRoute: typeof AuthenticatedOpportunityOpportunityIdRouteRoute
    }
    '/_authenticated/opportunity/$opportunityId/contact/$contactId/': {
      id: '/_authenticated/opportunity/$opportunityId/contact/$contactId/'
      path: '/'
      fullPath: '/opportunity/$opportunityId/contact/$contactId/'
      preLoaderRoute: typeof AuthenticatedOpportunityOpportunityIdContactContactIdIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/users/$userId': {
      id: '/_authenticated/admin/organizations/$organizationId/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/organizations/$organizationId/users/$userId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId'
      path: '/opportunities/$opportunityId'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/contacts/$contactId': {
      id: '/_authenticated/admin/organizations/$organizationId/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/admin/organizations/$organizationId/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId': {
      id: '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/admin/opportunity/$opportunityId/contact/$contactId'
      preLoaderRoute: typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOpportunityOpportunityIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/'
      path: '/'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/contacts/$contactId/': {
      id: '/_authenticated/admin/organizations/$organizationId/contacts/$contactId/'
      path: '/'
      fullPath: '/admin/organizations/$organizationId/contacts/$contactId/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute
    }
    '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId/': {
      id: '/_authenticated/admin/opportunity/$opportunityId/contact/$contactId/'
      path: '/'
      fullPath: '/admin/opportunity/$opportunityId/contact/$contactId/'
      preLoaderRoute: typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements'
      path: '/requirements'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts'
      path: '/contacts'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId'
      path: '/$requirementsId'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/requirements/$requirementsId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/'
      path: '/'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations'
      path: '/evaluations'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute
    }
    '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId': {
      id: '/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId'
      path: '/$evaluationId'
      fullPath: '/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations/$evaluationId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute
    }
  }
}

interface AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteChildren {
  AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute: typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute
}

const AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteChildren: AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteChildren =
  {
    AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute:
      AuthenticatedAdminOpportunityOpportunityIdContactContactIdIndexRoute,
  }

const AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteWithChildren =
  AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute._addFileChildren(
    AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteChildren,
  )

interface AuthenticatedAdminOpportunityOpportunityIdRouteRouteChildren {
  AuthenticatedAdminOpportunityOpportunityIdIndexRoute: typeof AuthenticatedAdminOpportunityOpportunityIdIndexRoute
  AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute: typeof AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
}

const AuthenticatedAdminOpportunityOpportunityIdRouteRouteChildren: AuthenticatedAdminOpportunityOpportunityIdRouteRouteChildren =
  {
    AuthenticatedAdminOpportunityOpportunityIdIndexRoute:
      AuthenticatedAdminOpportunityOpportunityIdIndexRoute,
    AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRoute:
      AuthenticatedAdminOpportunityOpportunityIdContactContactIdRouteRouteWithChildren,
  }

const AuthenticatedAdminOpportunityOpportunityIdRouteRouteWithChildren =
  AuthenticatedAdminOpportunityOpportunityIdRouteRoute._addFileChildren(
    AuthenticatedAdminOpportunityOpportunityIdRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute:
      AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdIndexRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsEvaluationIdRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdEvaluationsRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdIndexRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteWithChildren
}

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsContactIdRouteRouteWithChildren,
  }

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRequirementsIdRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdContactsRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRequirementsRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdIndexRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsOrganizationIdRouteRouteChildren {
  AuthenticatedAdminOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdIndexRoute
  AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute
}

const AuthenticatedAdminOrganizationsOrganizationIdRouteRouteChildren: AuthenticatedAdminOrganizationsOrganizationIdRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsOrganizationIdIndexRoute:
      AuthenticatedAdminOrganizationsOrganizationIdIndexRoute,
    AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdContactsContactIdRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdOpportunitiesOpportunityIdRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute:
      AuthenticatedAdminOrganizationsOrganizationIdUsersUserIdRoute,
  }

const AuthenticatedAdminOrganizationsOrganizationIdRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsOrganizationIdRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsOrganizationIdRouteRouteChildren,
  )

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminDemoRoute: typeof AuthenticatedAdminDemoRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminOpportunityOpportunityIdRouteRoute: typeof AuthenticatedAdminOpportunityOpportunityIdRouteRouteWithChildren
  AuthenticatedAdminOrganizationsOrganizationIdRouteRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRouteRouteWithChildren
  AuthenticatedAdminContactsRandomRoute: typeof AuthenticatedAdminContactsRandomRoute
  AuthenticatedAdminOpportunitiesRandomRoute: typeof AuthenticatedAdminOpportunitiesRandomRoute
  AuthenticatedAdminUsersUserIdRoute: typeof AuthenticatedAdminUsersUserIdRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
  AuthenticatedAdminAviaryTasksTaskIdRoute: typeof AuthenticatedAdminAviaryTasksTaskIdRoute
  AuthenticatedAdminAviaryTasksIndexRoute: typeof AuthenticatedAdminAviaryTasksIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminDemoRoute: AuthenticatedAdminDemoRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
    AuthenticatedAdminOpportunityOpportunityIdRouteRoute:
      AuthenticatedAdminOpportunityOpportunityIdRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsOrganizationIdRouteRoute:
      AuthenticatedAdminOrganizationsOrganizationIdRouteRouteWithChildren,
    AuthenticatedAdminContactsRandomRoute:
      AuthenticatedAdminContactsRandomRoute,
    AuthenticatedAdminOpportunitiesRandomRoute:
      AuthenticatedAdminOpportunitiesRandomRoute,
    AuthenticatedAdminUsersUserIdRoute: AuthenticatedAdminUsersUserIdRoute,
    AuthenticatedAdminOrganizationsIndexRoute:
      AuthenticatedAdminOrganizationsIndexRoute,
    AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
    AuthenticatedAdminAviaryTasksTaskIdRoute:
      AuthenticatedAdminAviaryTasksTaskIdRoute,
    AuthenticatedAdminAviaryTasksIndexRoute:
      AuthenticatedAdminAviaryTasksIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteChildren {
  AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute: typeof AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute
}

const AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteChildren: AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteChildren =
  {
    AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute:
      AuthenticatedOpportunityOpportunityIdContactContactIdIndexRoute,
  }

const AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteWithChildren =
  AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute._addFileChildren(
    AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteChildren,
  )

interface AuthenticatedOpportunityOpportunityIdRouteRouteChildren {
  AuthenticatedOpportunityOpportunityIdIndexRoute: typeof AuthenticatedOpportunityOpportunityIdIndexRoute
  AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute: typeof AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteWithChildren
}

const AuthenticatedOpportunityOpportunityIdRouteRouteChildren: AuthenticatedOpportunityOpportunityIdRouteRouteChildren =
  {
    AuthenticatedOpportunityOpportunityIdIndexRoute:
      AuthenticatedOpportunityOpportunityIdIndexRoute,
    AuthenticatedOpportunityOpportunityIdContactContactIdRouteRoute:
      AuthenticatedOpportunityOpportunityIdContactContactIdRouteRouteWithChildren,
  }

const AuthenticatedOpportunityOpportunityIdRouteRouteWithChildren =
  AuthenticatedOpportunityOpportunityIdRouteRoute._addFileChildren(
    AuthenticatedOpportunityOpportunityIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOpportunityOpportunityIdRouteRoute: typeof AuthenticatedOpportunityOpportunityIdRouteRouteWithChildren
  AuthenticatedDocsAviaryRoute: typeof AuthenticatedDocsAviaryRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOpportunityOpportunityIdRouteRoute:
    AuthenticatedOpportunityOpportunityIdRouteRouteWithChildren,
  AuthenticatedDocsAviaryRoute: AuthenticatedDocsAviaryRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SynthwaveRoute: SynthwaveRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
